// NOT USED
import { SafeJSON } from './../../shared/safe-json';

export class CaseEventHistory {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }
    getCode(): string {
        return SafeJSON.get('caseEvent.code', this.json);
    }
    getCaseEventHistoryKey(): string {
        return this.key;
    }
    getCaseEventHistoryDate(caseEvent: any): string {
        let clockDate = SafeJSON.get('clockDate', caseEvent.json);
        return clockDate;
    }
    getCaseEventHistoryTime(caseEvent: any): string {
        return '*01:00PM';
    }
    getCaseEventHistoryJudgementAbstracts(caseEvent: any): string {
        return '*JUDGMENT ABSTRACTS';
    }
    getCaseEventHistoryActivityDescription(caseEvent: any): string {
       return SafeJSON.getWithDefault('caseEvent.description', caseEvent.json);
    }
    getCaseEventHistoryPertainingTo(caseEvent: any): string {
        return '*JUDGMENT 1; P00001';
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/caseEventHistory.ts